import React from 'react';
import FranchiseCompanyDashboard from '../components/FranchiseCompanyDashboard';

export default function Bober() {
  return (
    <FranchiseCompanyDashboard
      icon="🦫"
      title="Бобёрмастер Россия"
      subtitle="Отдельная франшизная сеть, будет подключена к МойСклад своим токеном"
      color="#00a7dc"
      networkSize="~40"
      moneyTarget="Tochka ИП"
      tokenEnvName="BOBER_MOYSKLAD_TOKEN"
      network="bober"
    />
  );
}
